import { lighten } from "polished";
import styled from "styled-components";

export const ContratoReformar = styled.tr<any>`
  cursor: pointer;

  background: ${(p) => (p.active ? p.theme.colors.green : p.theme.colors.lightGray)} !important;
  color: ${(p) => (p.active ? "white" : p.theme.colors.text)} !important;

  &:hover {
    background: ${(p) => (p.active ? "" : lighten(0.4, p.theme.colors.primary))} !important;
  }
`;
